/**
 * @fileoverview Section-heading layout widget.
 * @module inspection-renderer/fields
 *
 * Responsibilities:
 * - Layout-only. Renders `<h3>` heading + optional helpText. No value.
 * - G-025 — mobile-pwa lacked this; this implementation delivers it.
 *
 * @component SectionHeadingField
 *
 * @contract SectionHeadingFieldProps
 * Purpose: prop contract for the layout-only heading widget.
 */
import type { InspectionFormField, ResolvedFieldStateV2 } from '@firesquirrel/core-domain';

export interface SectionHeadingFieldProps {
  field: InspectionFormField;
  resolved?: ResolvedFieldStateV2;
}

export function SectionHeadingField({ field, resolved }: SectionHeadingFieldProps) {
  if (resolved?.hidden) return null;
  return (
    <div data-field-id={field.id} data-widget-type="section" className="border-t border-gray-200 pt-3 mt-2">
      <h3 className="text-sm font-semibold text-gray-700">{field.label}</h3>
      {field.helpText && <p className="text-xs text-gray-500 mt-1">{field.helpText}</p>}
    </div>
  );
}
